import { TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'
import './style.css'

// `maxLength` (optionnel) active un garde-fou rétro-compatible :
//   - cap natif de saisie (l'input ne dépasse jamais la limite)
//   - compteur "x/limite" sous le champ (showCount, activé par défaut)
//   - passage en erreur + message quand la limite est atteinte
// Sans `maxLength`, le composant se comporte exactement comme avant.
export const Input = ({
  name,
  classAttr,
  control,
  rules,
  label,
  inputProps,
  maxLength,
  showCount = true,
  ...rest
}) => {
  const mergedRules = {
    ...rules,
    ...(maxLength
      ? {
          maxLength: {
            value: maxLength,
            message: `Limite de ${maxLength} caractères atteinte`,
          },
        }
      : {}),
  }
  return (
    <div className={classAttr} style={{ margin: '10px 10px' }}>
      <Controller
        name={name}
        control={control}
        rules={mergedRules}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          // Le champ commentaire est piloté en dehors de react-hook-form via
          // rest.value : on prend la valeur effectivement affichée pour le compteur.
          const effectiveValue = rest.value !== undefined ? rest.value : value
          // LAP — avant ce correctif, `feedback` restait `{}` tant que
          // `maxLength` n'était pas fourni : une règle `rules={{ required: true }}`
          // (utilisée par ~70 formulaires dans l'app) faisait bien bloquer la
          // soumission par react-hook-form, mais SANS jamais afficher le
          // contour rouge ni le message d'erreur — l'utilisateur ne voyait
          // alors rien se passer au clic sur "Valider". On affiche donc
          // toujours l'état d'erreur de react-hook-form, et on garde la
          // logique spécifique au compteur de caractères par-dessus quand
          // `maxLength` est fourni.
          const feedback = {
            error: !!error,
            helperText: error?.message,
          }
          if (maxLength) {
            const len =
              effectiveValue == null ? 0 : String(effectiveValue).length
            feedback.error = !!error || len >= maxLength
            feedback.helperText =
              error?.message || (showCount ? `${len}/${maxLength}` : undefined)
            feedback.inputProps = { maxLength }
          }
          return (
            <TextField
              sx={{ bgcolor: 'white' }}
              {...inputProps}
              fullWidth
              size="small"
              onChange={onChange}
              value={value}
              label={label}
              {...feedback}
              {...rest}
            />
          )
        }}
      />
    </div>
  )
}
